(() => {
  'use strict';

  if (window.__HARDRIP_CHATTY_STABILITY_V20206__) return;
  window.__HARDRIP_CHATTY_STABILITY_V20206__ = true;

  const TRIGGER = '#Avada-FAQ_WidgetTrigger';
  const POPUP = '.Avada-Faqs_Popup';
  const OPEN_CLASS = 'Avada-Faqs_Popup--Open';
  const HOME_SEARCH = 'button.Avada-Faqs_Search-Article';
  const CLOSE_SELECTOR = [
    '.Avada-Faqs_HeaderClose-button',
    '[aria-label="Close"]',
    '[aria-label="Chiudi"]',
    '[title="Close"]',
    '[title="Chiudi"]',
    '[class*="HeaderClose"]'
  ].join(',');
  const FIXED_SEARCH_MARK = 'data-hardrip-chatty-search-clean-v20206';

  let wiredPopup = null;
  let rootObserver = null;
  let contentObserver = null;
  let bodyObserver = null;

  let motionUntil = 0;
  let dragActive = false;
  let maintenanceTimer = 0;
  let idleHandle = 0;

  let homeResetArmed = false;
  let homeResetToken = 0;
  let homeResetAttempts = 0;
  let homeResetTimer = 0;

  const now = () => performance.now();
  const openPopup = () => document.querySelector(`${POPUP}.${OPEN_CLASS}`) || null;

  const installStyle = () => {
    if (document.getElementById('hardrip-chatty-stability-v20206-style')) return;
    const style = document.createElement('style');
    style.id = 'hardrip-chatty-stability-v20206-style';
    style.textContent = `
      /* HARDRIP V20.206
         Nothing here changes Chatty popup transform, bottom, opacity,
         visibility, transition or animation. Native motion stays native. */
      .Avada-Faqs_Popup :is(
        input[placeholder="Cerca aiuto" i],
        input[placeholder="Search for help" i],
        input[placeholder*="help" i],
        [${FIXED_SEARCH_MARK}="true"]
      ),
      .Avada-Faqs_Popup:not(.homePage)
      :is([class*="Search"], [class*="search"])
      :is(input, textarea, [role="textbox"], [contenteditable="true"], [class*="Input"], [class*="input"]) {
        background: transparent !important;
        background-color: transparent !important;
        background-image: none !important;
        border: 0 !important;
        border-color: transparent !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }

      .Avada-Faqs_Popup :is(
        input[placeholder="Cerca aiuto" i],
        input[placeholder="Search for help" i],
        input[placeholder*="help" i],
        [${FIXED_SEARCH_MARK}="true"]
      ):focus {
        background: transparent !important;
        background-color: transparent !important;
        background-image: none !important;
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  };

  const isHome = (popup) => {
    if (!(popup instanceof Element)) return false;
    const page = String(popup.getAttribute('data-chatty-page') || '').toLowerCase();
    if (page === 'homepage') return true;
    if (popup.classList.contains('homePage')) return true;
    if (popup.querySelector(HOME_SEARCH)) {
      const title = popup.querySelector(
        '.Avada-Faqs_HeaderTitle,[aria-label*="Come possiamo aiutarti" i],[aria-label*="How can we help" i]'
      );
      if (title) return true;
    }
    return false;
  };

  const cancelIdle = () => {
    if (!idleHandle) return;
    if ('cancelIdleCallback' in window) window.cancelIdleCallback(idleHandle);
    else clearTimeout(idleHandle);
    idleHandle = 0;
  };

  const cancelMaintenance = () => {
    if (maintenanceTimer) clearTimeout(maintenanceTimer);
    maintenanceTimer = 0;
    cancelIdle();
  };

  const motionBusy = () => dragActive || now() < motionUntil;

  const lockMotion = (ms = 700) => {
    motionUntil = Math.max(motionUntil, now() + ms);
    cancelMaintenance();
  };

  const deferIdle = (callback) => {
    cancelIdle();
    if ('requestIdleCallback' in window) {
      idleHandle = window.requestIdleCallback(() => {
        idleHandle = 0;
        callback();
      }, { timeout: 450 });
    } else {
      idleHandle = window.setTimeout(() => {
        idleHandle = 0;
        callback();
      }, 120);
    }
  };

  const cleanHelpSearch = (popup) => {
    if (!(popup instanceof Element) || !popup.isConnected) return;
    if (!popup.classList.contains(OPEN_CLASS) || isHome(popup) || motionBusy()) return;

    /* No getBoundingClientRect/getComputedStyle and no all-node scan here.
       The old patch forced layout while the bottom sheet was moving. */
    const controls = popup.querySelectorAll([
      'input[placeholder="Cerca aiuto" i]',
      'input[placeholder="Search for help" i]',
      'input[placeholder*="help" i]',
      '[class*="Search"] input',
      '[class*="search"] input',
      '[class*="Search"] [role="textbox"]',
      '[class*="search"] [role="textbox"]'
    ].join(','));

    controls.forEach((control) => {
      if (!(control instanceof HTMLElement)) return;
      control.setAttribute(FIXED_SEARCH_MARK, 'true');
    });
  };

  const findBackButton = (popup) => {
    if (!(popup instanceof Element)) return null;

    const buttons = popup.querySelectorAll('button,[role="button"]');
    for (const button of buttons) {
      if (button.matches(CLOSE_SELECTOR)) continue;
      const label = `${button.getAttribute('aria-label') || ''} ${button.getAttribute('title') || ''} ${button.textContent || ''}`;
      if (/indietro|back|torna|home/i.test(label) && !/close|chiudi/i.test(label)) return button;
    }

    const headerButtons = popup.querySelectorAll(
      '.Avada-Faqs_HeaderAction button,[class*="HeaderAction"] button,[class*="Header"] button'
    );
    for (const button of headerButtons) {
      if (button.matches(CLOSE_SELECTOR)) continue;
      const label = `${button.getAttribute('aria-label') || ''} ${button.getAttribute('title') || ''} ${button.className || ''}`;
      if (/close|chiudi|HeaderClose/i.test(label)) continue;
      if (button.querySelector('svg')) return button;
    }
    return null;
  };

  const cancelHomeResetTimer = () => {
    if (homeResetTimer) clearTimeout(homeResetTimer);
    homeResetTimer = 0;
  };

  const finishHomeReset = (token = homeResetToken) => {
    if (token !== homeResetToken) return;
    homeResetArmed = false;
    homeResetAttempts = 0;
    cancelHomeResetTimer();
  };

  const scheduleHomeResetAttempt = (token, delay = 120) => {
    if (!homeResetArmed || token !== homeResetToken) return;
    cancelHomeResetTimer();
    homeResetTimer = window.setTimeout(() => {
      homeResetTimer = 0;
      runHomeReset(token);
    }, delay);
  };

  const runHomeReset = (token = homeResetToken) => {
    if (!homeResetArmed || token !== homeResetToken) return;

    if (motionBusy()) {
      scheduleHomeResetAttempt(token, Math.max(100, Math.ceil(motionUntil - now()) + 100));
      return;
    }

    const popup = openPopup();
    if (!popup) {
      if (++homeResetAttempts <= 5) scheduleHomeResetAttempt(token, 140);
      else finishHomeReset(token);
      return;
    }

    if (isHome(popup)) {
      finishHomeReset(token);
      return;
    }

    const back = findBackButton(popup);
    if (!back) {
      if (++homeResetAttempts <= 4) scheduleHomeResetAttempt(token, 160);
      else finishHomeReset(token);
      return;
    }

    /* One navigation action at a time, only when all native motion is over. */
    homeResetAttempts += 1;
    back.click();
    lockMotion(260);
    if (homeResetAttempts <= 5) scheduleHomeResetAttempt(token, 380);
    else finishHomeReset(token);
  };

  const armHomeResetAfterOpen = () => {
    homeResetToken += 1;
    const token = homeResetToken;
    homeResetArmed = true;
    homeResetAttempts = 0;
    cancelHomeResetTimer();

    /* Let Chatty finish its own launcher/bottom-sheet opening first. */
    scheduleHomeResetAttempt(token, 900);
  };

  const runMaintenance = () => {
    maintenanceTimer = 0;
    if (motionBusy()) {
      scheduleMaintenance();
      return;
    }

    const popup = openPopup();
    if (!popup) return;

    if (homeResetArmed && !isHome(popup)) {
      scheduleHomeResetAttempt(homeResetToken, 80);
      return;
    }

    deferIdle(() => {
      if (motionBusy()) {
        scheduleMaintenance();
        return;
      }
      const current = openPopup();
      if (current) cleanHelpSearch(current);
    });
  };

  function scheduleMaintenance(extraDelay = 0) {
    cancelMaintenance();
    const remaining = Math.max(0, motionUntil - now());
    const delay = Math.max(180 + extraDelay, remaining + 120);
    maintenanceTimer = window.setTimeout(runMaintenance, delay);
  }

  const disconnectPopupObservers = () => {
    rootObserver?.disconnect();
    contentObserver?.disconnect();
    rootObserver = null;
    contentObserver = null;
  };

  const wirePopup = (popup) => {
    if (!(popup instanceof Element)) return;
    if (wiredPopup === popup && rootObserver && contentObserver) return;

    disconnectPopupObservers();
    wiredPopup = popup;

    /* Observers only schedule later work. They never read layout, compute style,
       click navigation or write popup styles from their callbacks. */
    rootObserver = new MutationObserver(() => {
      if (!popup.isConnected) return;
      if (!popup.classList.contains(OPEN_CLASS)) {
        lockMotion(500);
        cancelMaintenance();
        return;
      }
      scheduleMaintenance(80);
    });
    rootObserver.observe(popup, {
      attributes: true,
      attributeFilter: ['class', 'data-chatty-page']
    });

    contentObserver = new MutationObserver(() => {
      if (!popup.isConnected || !popup.classList.contains(OPEN_CLASS)) return;
      scheduleMaintenance(100);
    });
    contentObserver.observe(popup, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['placeholder']
    });

    if (popup.classList.contains(OPEN_CLASS)) scheduleMaintenance(120);
  };

  const findAndWirePopup = () => {
    const popup = document.querySelector(POPUP);
    if (popup) wirePopup(popup);
  };

  const targetElement = (event) => event.target instanceof Element ? event.target : null;

  const startsOnClose = (event) => {
    const target = targetElement(event);
    return !!target?.closest(CLOSE_SELECTOR);
  };

  const startsInsideOpenPopup = (event) => {
    const target = targetElement(event);
    return !!target?.closest(`${POPUP}.${OPEN_CLASS}`);
  };

  const startsOnTrigger = (event) => {
    const target = targetElement(event);
    return !!target?.closest(TRIGGER);
  };

  const onPointerDown = (event) => {
    if (startsOnTrigger(event) && !openPopup()) {
      /* No DOM route mutation while the launcher opens. */
      lockMotion(900);
      armHomeResetAfterOpen();
      return;
    }

    if (!startsInsideOpenPopup(event)) return;

    if (startsOnClose(event)) {
      dragActive = false;
      lockMotion(900);
      return;
    }

    if (event.pointerType === 'touch' || event.pointerType === 'pen' || !event.pointerType) {
      dragActive = true;
      lockMotion(1400);
    }
  };

  const onPointerMove = () => {
    if (!dragActive) return;
    /* Timestamp only. Zero DOM reads/writes while the finger moves. */
    motionUntil = Math.max(motionUntil, now() + 700);
  };

  const endDrag = () => {
    if (!dragActive) return;
    dragActive = false;
    lockMotion(650);
    scheduleMaintenance(80);
  };

  const onClick = (event) => {
    if (startsOnClose(event)) {
      dragActive = false;
      lockMotion(900);
      return;
    }
    if (startsOnTrigger(event) && !openPopup()) {
      lockMotion(900);
      if (!homeResetArmed) armHomeResetAfterOpen();
    }
  };

  const onNativeMotionStart = (event) => {
    const target = targetElement(event);
    if (!target?.closest(POPUP)) return;
    lockMotion(900);
  };

  const onNativeMotionEnd = (event) => {
    const target = targetElement(event);
    if (!target?.closest(POPUP)) return;
    motionUntil = Math.max(motionUntil, now() + 140);
    scheduleMaintenance(80);
  };

  installStyle();

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointermove', onPointerMove, true);
  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);
  document.addEventListener('click', onClick, true);
  document.addEventListener('transitionrun', onNativeMotionStart, true);
  document.addEventListener('transitionstart', onNativeMotionStart, true);
  document.addEventListener('transitionend', onNativeMotionEnd, true);
  document.addEventListener('animationstart', onNativeMotionStart, true);
  document.addEventListener('animationend', onNativeMotionEnd, true);

  const startBodyObserver = () => {
    if (bodyObserver || !document.body) return;
    bodyObserver = new MutationObserver((mutations) => {
      let relevant = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.(POPUP) || node.querySelector?.(POPUP)) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
        for (const node of mutation.removedNodes) {
          if (!(node instanceof Element)) continue;
          if (wiredPopup && (node === wiredPopup || node.contains?.(wiredPopup))) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
      }

      if (!relevant) return;
      if (wiredPopup && !wiredPopup.isConnected) {
        disconnectPopupObservers();
        wiredPopup = null;
        cancelMaintenance();
      }
      findAndWirePopup();
      scheduleMaintenance(100);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  };

  const boot = () => {
    findAndWirePopup();
    startBodyObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('pageshow', () => {
    findAndWirePopup();
    startBodyObserver();
    scheduleMaintenance(120);
  });
})();
